import { VStack } from "@chakra-ui/react"
import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"
import { getSyncableChangesCount } from "@pathwright/web/src/modules/path/sync/utils"
import pluralize from "pluralize"
import SuggestedAction from "./SuggestedAction"
import { useSyncCard } from "./SyncCardProvider"
import { SYNC_DIR_BACKWARD } from "./constants"

type Props = {
  withWrapper?: boolean
}

const BackSyncItem = ({ withWrapper }: Props) => {
  const { t, tc } = useTranslate()

  const { fromCohort, syncPlanContext, onSetSyncDir } = useSyncCard()

  const syncableBackwardChanges = getSyncableChangesCount(
    syncPlanContext?.backward
  )

  const numCohorts = fromCohort?.resource?.cohorts?.total || 0

  if (!syncableBackwardChanges || !numCohorts) return null

  const cardItem = (
    <SuggestedAction
      label={tc(`Sync {{syncableBackwardChanges}} {{changes}} to Source Path`, {
        syncableBackwardChanges,
        changes: pluralize("change", syncableBackwardChanges)
      })}
      icon="cloud-arrows-fill"
      onClick={() => onSetSyncDir?.(SYNC_DIR_BACKWARD)}
    />
  )

  return withWrapper ? (
    <VStack py={10} px={10} gap={16} bg="gray.300" w="full" align="start">
      {cardItem}
    </VStack>
  ) : (
    cardItem
  )
}

export default BackSyncItem
